import { createSlice, current } from '@reduxjs/toolkit';
import {
	getWaterSourceTypeList,
	getWaterSourceType,
	addNewWaterSourceType,
	updateWaterSourceType,
	deleteWaterSourceType,
	checkWaterSourceTypeExists,
} from './thunk';

export const initialState = {
	itemWaterSourceTypeList: [],
	itemWaterSourceType: null,
	isWaterSourceTypeLoading: false,
	isWaterSourceTypeSuccess: false,
	dataWaterSourceType: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const WaterSourceTypeSlice = createSlice({
	name: 'WaterSourceType',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getWaterSourceTypeList.pending, state => {
			state.isLoadingList = true;
			state.isWaterSourceTypeSuccess = false;
		});

		builder.addCase(getWaterSourceTypeList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemWaterSourceTypeList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isWaterSourceTypeSuccess = true;
		});

		builder.addCase(getWaterSourceTypeList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isWaterSourceTypeSuccess = false;
		});

		builder.addCase(getWaterSourceType.pending, state => {
			state.isWaterSourceTypeLoading = true;
			state.isWaterSourceTypeSuccess = false;
		});

		builder.addCase(getWaterSourceType.fulfilled, (state, action) => {
			state.itemWaterSourceType = action.payload;
			state.isWaterSourceTypeLoading = false;
			state.isWaterSourceTypeSuccess = true;
		});

		builder.addCase(getWaterSourceType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isWaterSourceTypeLoading = false;
			state.isWaterSourceTypeSuccess = false;
		});

		builder.addCase(addNewWaterSourceType.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewWaterSourceType.fulfilled, (state, action) => {
			state.itemWaterSourceTypeList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewWaterSourceType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateWaterSourceType.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateWaterSourceType.fulfilled, (state, action) => {
			state.itemWaterSourceTypeList = state.itemWaterSourceTypeList.map(
				item =>
					item._id.toString() === action.payload._id.toString()
						? { ...item, ...action.payload }
						: item
			);
			state.statementList = state.statementList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? { ...item, item: action.payload, label: action.payload.name }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(updateWaterSourceType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteWaterSourceType.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteWaterSourceType.fulfilled, (state, action) => {
			state.itemWaterSourceTypeList = current(state.itemWaterSourceTypeList)
				.filter(item => item._id !== action.payload._id);
			state.statementList = current(state.statementList)
				.filter(item => item._id !== action.payload._id);
			state.statementListSelect = current(state.statementListSelect)
				.filter(item => item.value !== action.payload._id);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDeleteError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteWaterSourceType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkWaterSourceTypeExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkWaterSourceTypeExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkWaterSourceTypeExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = WaterSourceTypeSlice.actions;

export default WaterSourceTypeSlice.reducer;
